import React from 'react'
import ExpensesNeedsApproval from 'src/app/ExpensesNeedsApproval/ExpensesNeedsApproval'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { managerReviewTransactionsRouteProps } from 'src/navigation/routeProps'

const ManagerReviewTransactionsAppRoute: AppRoute = {
  id: AppLocation.ManagerReviewTransactions,
  routeProps: managerReviewTransactionsRouteProps,
  component: <ExpensesNeedsApproval />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ManagerReviewTransactionsAppRoute